export var MAX_DEGREE = 160;
export var _smoothness = {
    1: 0.1,
    2: 0.02,
    3: 0.001,
    4: 0.0005,
    5: 0.0002,
};
var _calculatedFactorials = [1];
var _binomialCoefficients = {};
/* -------------------------------------------------------------------------- */
function _helper_ensureFactorials(n) {
    var prevLen = _calculatedFactorials.length;
    for (var i = prevLen; i <= n; i++)
        _calculatedFactorials[i] = i * _calculatedFactorials[i - 1];
}
function _f(i) {
    return _calculatedFactorials[i];
}
/* -------------------------------------------------------------------------- */
function _helper_ensureBinomialCoefficients(_n) {
    for (var n = 2; n <= _n; n++) {
        _binomialCoefficients[n] = {};
        for (var i = 1; i < n; i++) {
            _binomialCoefficients[n][i] = _f(n) / (_f(i) * _f(n - i));
        }
    }
}
export function _binomialCoefficient(n, i) {
    if (i === 0 || i === n)
        return 1;
    return _binomialCoefficients[n][i];
}
/* -------------------------------------------------------------------------- */
_helper_ensureFactorials(MAX_DEGREE + 1);
_helper_ensureBinomialCoefficients(MAX_DEGREE + 1);
